import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralStyle = styled.div`
  width: 100%;
  height: fit-content;
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  .users-container {
    display: grid;
    grid-template-columns: 35% 50% 10%;
    grid-gap: 20px;
    margin-left: 0px;
    background-color: ${({ theme }) => theme.background.tertiary};
    margin-top: 10px;
    padding-right: 15px;
    width: 100%;
    padding: 0 3%;
  }
`;
export const ContentFields = styled.div`
  display: grid;
  grid-template-columns: 90%;
  padding: 10px 30px;
  label {
    font-weight: 600;
    font-size: 13px;
    color: ${({ theme }) => theme.primary.purple} !important;
  }
  input::placeholder,
  textarea::placeholder {
    color: rgba(46, 46, 46, 0.4);
    font-size: 13px;
  }
`;
export const ContentFile = styled.div`
  width: 100%;
  height: 12em;
  margin: auto;
`;
export const FieldFile = styled.div`
  height: 12em;
  display: grid;
  grid-auto-rows: 0em auto;
  label {
    color: rgb(143, 155, 179);
  }
`;
export const ContentButtons = styled.div`
  width: 19em;
  display: flex;
  grid-gap: 1em;
  margin: 1em 2.5em;
  height: 60px;
`;
export const ButtonCancel = styled.button`
  background: ${({ theme }) => theme.neutral.white};
  color: ${({ theme }) => theme.button.primary};
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.primary.purple};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  height: 43.21px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const ButtonCreate = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  height: 43.21px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const TextField = styled.div``;

export const DateField = styled.div`
  input {
    background-color: ${({ theme }) => theme.background.tertiary};
    width: 48%;
    font-size: 13px;
    height: calc(1.5em + 0.75rem + 6px);
  }
  .date-fld {
    display: flex;
  }
`;
export const TextAreaField = styled.div`
  textarea {
    height: 54px;
  }
`;

export const RowOne = styled.div`
  display: grid;
  grid-template-columns: 30% 30% 37.5%;
  grid-gap: 1em;
`;

export const RowTwo = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: 61% 37.5%;
  grid-gap: 1em;
`;

export const InfoLabel = styled.div`
  margin-top: 100px;
  display: flex;
  justify-content: flex-end;
`;
